module.exports = __webpack_public_path__ + "static/img/global_warm_prompt_22x22_@3x.5a50b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_warm_prompt_22x22_@3x.png
// module id = 8dXc
// module chunks = 1